module.exports = __webpack_public_path__ + "static/img/200201.cb4cb1dc.png";